import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'environments/environment';
import { UserSessionService } from './usersession.service';
import { DataService } from './data.service';
import { UserSession } from '../models/usersession';
import * as jwtDecode from 'jwt-decode';
import * as momenttz from 'moment-timezone';
import * as _ from 'lodash';

import 'rxjs/add/operator/map';
import { ActiveUserSessionService } from './activeusersession.service';
declare var require: any;
const timezone = require('../assets/timezones.json');

@Injectable()
export class AuthenticationService {

  private baseUrl = environment.apiBaseUrl;
  timeZones: any[];
  sessionData = new UserSession();
  pageAccess: boolean = true;
  constructor(
    private http: HttpClient,
    private dataService: DataService,
    private activeUserSessionService: ActiveUserSessionService,
    private sessionService: UserSessionService) {
    this.getTimeZones();
  }

  login(username: string, password: string, pin: any = null, isRegister: boolean = false, isLoginFirstCard: boolean = false, claims:any= null) {
    const headers = new HttpHeaders(
      {
        'Content-Type': 'application/json',
        // con.setRequestProperty("Content-Type", "application/json; charset=utf8")
      });

    const timeZone = this.getBrowserTimeZone();
    // const data = 'username=' + username + '&password=' + password + '&timezone=' + timeZone;
    const captchaToken = localStorage.getItem('Captchatoken');

    var tempToken = "";

    if (!isLoginFirstCard && !isRegister) {
      tempToken = this.sessionService.authToken();
    }
    var data: any;
    if (claims == null) {
      data = { username: username, password: password, pin: pin, isRegister: isRegister, timezone: timeZone, captchaToken: captchaToken, tempToken: tempToken };
    }
    else {
      data = { username: username, password: password, pin: pin, isRegister: isRegister, timezone: timeZone,claims:claims};
    }
    return this.http.post<any>(this.baseUrl + '/api/token', data, { headers: headers })
      .map(res => {
        if (res && res.isSuccess && res.value) {
          var user: any = {}
          user.access_token = res.value;
          this.clearCachedMenu();
          const decodedToken = jwtDecode(user.access_token);
          this.sessionData.authToken = user.access_token;
          this.sessionData.userId = decodedToken['user.id'];
          this.sessionData.userFullName = decodedToken['user.fullname'];
          this.sessionData.userFirstName = decodedToken['user.firstname'];
          this.sessionData.userLastName = decodedToken['user.lastname'];
          this.sessionData.identificationNo = decodedToken['user.identificationnumber'];
          this.sessionData.mobileNo = decodedToken['user.mobilenumber'];
          this.sessionData.whatsAppNumber = decodedToken['user.whatsappnumber'];
          this.sessionData.email = decodedToken['user.email'];
          this.sessionData.roleId = decodedToken['user.roleid'];
          this.sessionData.roleName = decodedToken['user.rolename'];
          this.sessionData.mustChangePassword = decodedToken['user.mustChangePassword'] === 'true';
          this.sessionService.create(this.sessionData);
        }
        return res
      });
  }

  isAuthenticated() {
    return !!this.sessionService.userId() && !!this.sessionService.authToken();
  }

  isPageAccessAvailable(pageUrl, pageTitle) {

    const rolePages = this.activeUserSessionService.getRolePage() ? this.activeUserSessionService.getRolePage() : [];
    // const pages = JSON.parse(rolePages);
    // const pages = JSON.parse('');
    // console.log(JSON.stringify(pages));  
    const pages = rolePages;
    const paths = ['/dashboard'];
    const applicationPath = '/applicationform';
    if (pages && pages.length > 0) {
      pages.forEach(field => {
        if (field.path) {
          paths.push(field.path);
          paths.push(field.title);
        }

        if (field.submenu && field.submenu.length > 0) {
          field.submenu.forEach(field1 => {
            if (field1.path) {
              paths.push(field1.path);
              paths.push(field1.title);
            }
          });

        }
      });

      paths.push(applicationPath);
      paths.push("Payments");
      this.pageAccess = (paths.indexOf(pageUrl) >= 0) || (paths.indexOf(pageTitle) >= 0) ? true : false;
    }
    // console.log(pageUrl,pageTitle);

    return this.pageAccess;
  }
  hasRequiredPermission(permission) {
    for (let i = 0; i < permission.length; i++) {
      if (permission[i] === this.sessionService.roleId()) {
        return true;
      }
    }
    return false;
  }

  getTimeZones() {
    this.timeZones = timezone.timeZone;
  }

  getBrowserTimeZone(): string {
    const zoneName = momenttz.tz.guess();
    const temptimezone = momenttz.tz(zoneName).zoneAbbr();
    const filterZone = this.timeZones.find(i => i.abbr === temptimezone);
    if (filterZone) {
      return filterZone.value;
    }
    return '';
  }

  clearCachedMenu() {
    this.dataService.clearCache();
  }

  clearSession() {
    this.sessionService.destroy();
    this.clearCachedMenu();
  }

  logOut() {
    this.clearCachedMenu();
    localStorage.clear();
    // this.sessionService.destroy();
    // this.activeUserSessionService.destroy();
    // this.activeUserSessionService.destroyProductId();
    // this.activeUserSessionService.destroyUnitName();
    // this.activeUserSessionService.destroyUnitNo();
    // this.activeUserSessionService.destroyRolePage();
    // this.activeUserSessionService.destroyIsAllowFriendMenu();
  }

  verifyCaptchaAndGenerateOTP(data) {
    return this.dataService.post('/api/user/verifyCaptchaAndGenerateOtp', data)
  }


  GenerateOTP(data) {
    return this.dataService.post('/api/user/GenerateOtp', data)
  }
  validateOtp(data) {
    return this.dataService.post('/api/user/ValidateOtp', data)
  }
  GetOtpNotificationMessage() {
    return this.dataService.getRecord('/api/notificationmessageinfo/GetOtpNotificationMessage')
  }

  checkEmailAndIdNumberExistOrNot(data) {
    return this.dataService.getRecordWithParams('/api/user/checkEmailAndIdNumberExistOrNot', data)
  }

  checkUserCredentials(data) {
    return this.dataService.post('/api/user/checkUserCredentials', data)
  }

  createSupportTicket(data) {
    return this.dataService.post('/api/Support/createSupportTicket', data)
  }

  createTroubleInSignInTicket(data) {
    return this.dataService.post('/api/support/createLoginSupportTicket', data)
  }
}
